export enum ValidationText {
    Pattern = 'must match the following pattern:',
    Min = 'must be greater than or equal to',
    Max = 'must be less than or equal to',
    Required = 'is required',
    MinlengthStart = 'must be at least',
    MaxlengthStart = 'must be at most',
    LengthEnd = 'characters long',
    Email = 'must be an email',
    EmailDelimited = 'must be a list of emails delimited by',
    EmailList = 'invalid email addresses. Please fix or remove them.',
    EmailListSingular = 'invalid email address. Please fix or remove it.',
    RequiredTrue = 'must be an checked',
    Url = 'is an invalid URL.',
    InvalidFqlFieldsSingular = 'isn\'t in your data. Update the product selection to match your data.',
    InvalidFqlFields = 'aren\'t in your data. Update the product selection to match your data.'
}
